import { Component, OnInit } from "@angular/core";
import { BuNameService } from "../../helper/core/bu-name.service";
import { CoreService } from "../../helper/core/core.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  ValidatorFn,
  AbstractControl,
  FormArray,
} from "@angular/forms";
import { Constant } from "../../helper/core/constant";
import { UtilsService } from "../../helper/utils/utils.service";
import { NgSelectComponent } from "@ng-select/ng-select";
import { RgaaSelectComponent } from "../../components/rgaa-select/rgaa-select.component";
import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

const emailOrangePattern: RegExp =
  /^[^@\s]+(@{1}orange.com$|@{1}insitaction.com)$/;

// const CUIDPattern: RegExp = /[a-zA-Z][a-zA-Z][a-zA-Z][a-zA-Z][0-9][0-9][0-9][0-9]/
const departementPattern: RegExp = /^[0-9]\d{0,2}(?:\,\d{1,3})?$/;

function emailOrangeValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return emailOrangePattern.test(control.value)
      ? null
      : { orangeEmail: true };
  };
}

function emailExtOrangeValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return !control.value.includes(".ext@orange.com")
      ? null
      : { orangeNoExtEmail: true };
  };
}

function departementValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    return departementPattern.test(control.value)
      ? null
      : { departement: true };
  };
}

@Component({
  selector: "app-form-voluntary",
  templateUrl: "./form-voluntary.component.html",
  styleUrls: ["./form-voluntary.component.scss"],
})
export class FormVoluntaryComponent implements OnInit {
  voluntaryForm: FormGroup;
  public step: string = "one";
  public modalHelper: any = {
    name: "",
    message: "",
    mail: "",
    open: false,
  };
  public dataHelper: any;
  public dynamicValues = {
    axes: [
      {
        id: 1,
        name: "Egalité Numérique (Ateliers Numériques, SuperCodeurs, Ateliers Salariés...)",
      },
      { id: 2, name: "Innovation, Produits et services (5G, Multiservice...)" },
      {
        id: 3,
        name: "Environnement (Fresque du climat, atelier éco frugal...)",
      },
    ],
    programs: [],
    // events: [],
  };
  public entitysHelper;

  public entityOrangeFr;

  public disabledZoneDo: boolean = true;
  public regionsHelper: any = [
    { id: 1, name: "Ile-de-France" },
    { id: 2, name: "Grand Nord-Est" },
    { id: 3, name: "Grand Sud-Ouest" },
    { id: 4, name: "Grand Ouest" },
    { id: 5, name: "Grand Sud-Est" },
    { id: 6, name: "Caraïbes" },
    { id: 7, name: "Réunion – Mayotte" },
    { id: 8, name: "Autre" },
  ];
  public helperForm: any = [];
  public disponibility: any = [
    {
      id: "available_anim_orange_site",
      message: "Animation sur mon site Orange",
    },
    {
      id: "available_anim_geo_area",
      message: "Animation sur un site Orange de ma maille géographique",
    },
    {
      id: "available_external_site",
      message: "Animation sur un site externe de ma maille géographique",
    },
    {
      id: "available_remotely",
      message: "Animation à distance (tél. ou visio)",
    },
    {
      id: "available_ambassador",
      message: "Formation des animateurs",
    },
  ];
  // public eventsList: any = [];
  public programsList: any = [];
  public enableValidate: boolean = false;
  public optionDays: any = [1, 2, 3, 4, 5, 6].map((val) => ({
    id: val,
    name: `${val} ${val > 1 ? "jours" : "jour"}/année`,
  }));
  constructor(
    private buNameService: BuNameService,
    private coreService: CoreService,
    private fb: FormBuilder,
    private utils: UtilsService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    // Texte du header
    this.buNameService.name = "";
    this.buNameService.img = "default";

    // Champs du formulaire
    this.voluntaryForm = this.fb.group({
      first_name: new FormControl("", [Validators.required]),
      last_name: new FormControl("", [Validators.required]),
      professional_mail: new FormControl("", [
        Validators.required,
        emailOrangeValidator(),
        emailExtOrangeValidator(),
      ]),
      phone_number: new FormControl("", [Validators.pattern("^[0-9]*$")]),
      work_study: new FormControl(false),
      home_entity: new FormControl(null, [Validators.required]),
      entity_orangefrance: new FormControl(null, []),
      do_zone: new FormControl(null, [Validators.required]),
      city: new FormControl("", [Validators.required]),
      postal_code: new FormControl("", [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(4),
        Validators.maxLength(5),
      ]),
      postal_code_remote: new FormControl("", [
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(4),
        Validators.maxLength(5),
      ]),
      days_spent: new FormControl(null, [Validators.required]),
      manager_mail: new FormControl("", [
        Validators.required,
        emailOrangeValidator(),
        emailExtOrangeValidator(),
      ]),
      manager_firstname: new FormControl("", [Validators.required]),
      manager_lastname: new FormControl("", [Validators.required]),
      available_place: new FormControl("", [Validators.required]),
      rgpd_voluntary: new FormControl("", [Validators.requiredTrue]),
      digital_innovation: new FormControl(false),
      environment: new FormControl(false),
      digital_tools: new FormControl(false),
      digital_inclusion: new FormControl(false),
    });

    this.getParentEntities().subscribe(
      response => {
        this.entitysHelper = response; // Traitez les données ici
      },
      error => {
        console.error('Erreur lors de l\'appel API :', error);
      }
    );
    this.getPrecisionEntities().subscribe(
      response => {
        this.entityOrangeFr = response; // Traitez les données ici
      },
      error => {
        console.error('Erreur lors de l\'appel API :', error);
      }
    );
    
  }
  getParentEntities() {
    return this.http.get(`/api/parent-entities`);
  }

  getPrecisionEntities() {
    return this.http.get(`/api/precision-entities`);
  }

  voluntaryFormIsValid = () => {
    switch (this.step) {
      case "one":
        return (
          this.voluntaryForm.get("last_name").valid &&
          this.voluntaryForm.get("first_name").valid &&
          this.voluntaryForm.get("professional_mail").valid &&
          this.voluntaryForm.get("phone_number").valid
        );
      case "two":
        return (
          this.voluntaryForm.get("home_entity").valid &&
          this.voluntaryForm.get("entity_orangefrance").valid &&
          this.voluntaryForm.get("do_zone").valid &&
          this.voluntaryForm.get("city").valid &&
          this.voluntaryForm.get("postal_code").valid &&
          this.voluntaryForm.get("postal_code_remote").valid
        );
      case "three":
        return (
          this.voluntaryForm.get("days_spent").valid &&
          this.voluntaryForm.get("manager_firstname").valid &&
          this.voluntaryForm.get("manager_lastname").valid &&
          this.voluntaryForm.get("manager_mail").valid &&
          this.voluntaryForm.get("available_place").valid &&
          this.voluntaryForm.get("rgpd_voluntary").valid
        );
      case "four":
        return true;
    }
  };

  programsListValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      return this.programsList.length ? null : { noProgram: true };
    };
  }

  keyboardChoice = (event: KeyboardEvent): void => {
    // On va chercher toutes les options sur ng-select
    const parent = event.currentTarget;
    const select = $(parent).children()[1];
    const dropdown = $(select).children()[0];
    const optionsContainer = $(dropdown).children()[1];
    const options = $(optionsContainer).children();

    // On boucle sur toutes les options pour reset leurs styles
    for (let index = 0; index < options.length; index++) {
      const option = options[index];
      $(option).css("background-color", "white");
      $(option).css("color", "black");
    }

    // On ajoute le style voulu sur l'élement sélectionné avec les flèches :
    const element = $(
      `#${document.activeElement.getAttribute("aria-activedescendant")}`
    );
    element.css("background-color", "black");
    element.css("color", "white");
  };

  getErrorMessage(control: FormControl): string {
    const errorMessages = {
      required: () => `Ce champ est requis`,
      orangeEmail: () => `Ce n'est pas un format d'email valide '@orange.com'`,
      orangeNoExtEmail: () => `Les adresses externes orange ne sont pas valides`,
      departement: () => `Ce n'est pas un numéro de département valide`,
      default: () => `Ce champ contient au moins une erreur`,
    };
    let erreur = errorMessages.default();

    for (const type in errorMessages) {
      if (type !== "default" && control.hasError(type)) {
        erreur = errorMessages[type](control.getError(type));
        break;
      }
    }
    return erreur;
  }

  // Soumet les données du formulaire à la vérification
  onSubmit(): void {
    if (this.voluntaryForm.valid) {
      const payload = this.constructPayload(this.voluntaryForm.value);

      this.sendDatas(payload);
    } else {
      Object.keys(this.voluntaryForm.controls).forEach((x) => {
        this.voluntaryForm.controls[x].markAsTouched();
      });
      setTimeout(() => {
        this.utils.scrollToJqueryElem(
          $(".voluntary-form .error-message:first").closest(".column")
        );
      }, 300);
    }
  }

  // Envoie les données du formulaire
  sendDatas(datas) {
    this.coreService.sendDataVoluntary(datas).subscribe(
      (data) => {
        this.openModal(data, true);
        this.step = "four";
        // reset le form
        this.voluntaryForm.reset();
        // reset la liste des axes etc
        this.coreService.getOpenToVolunteersEvent().subscribe(
          (programs) => {
            if (programs.with_volunteer_activate.axes !== undefined) {
              this.dynamicValues = this.shapingData(
                programs.with_volunteer_activate.axes
              );
            }
          },
          (dataError) => {
            console.error(dataError);
          }
        );
      },
      (dataError) => {
        this.openModal(dataError, false);
      }
    );
  }

  // Affiche la modal front qui informe l'utilisateur
  openModal(informations, status) {
    if (status) {
      this.modalHelper = {
        name: "Merci, " + informations.name,
        message: "Vos informations ont bien été envoyées",
        mail: informations.mail,
        open: true,
      };
    } else {
      let err = informations.errors;
      let name = `Il y a ${err.length} ${err.length > 1 ? "erreurs" : "erreur"
        } dans le formulaire`;
      let msg = "";
      err.forEach((elem) => {
        msg += `- ${elem} <br />`;
      });

      this.modalHelper = {
        name: name,
        message: msg,
        mail: "",
        open: true,
      };
    }
  }

  // Ferme la modal
  closeModal() {
    this.modalHelper = {
      open: false,
    };
  }

  // Construit le payload
  constructPayload(values): any {
    const payload = {
      first_name: values.first_name,
      last_name: values.last_name,
      professional_mail: values.professional_mail,
      home_entity: values.home_entity,
      entity_orangefrance: values.entity_orangefrance,
      phone_number: values.phone_number,
      do_zone: values.do_zone,
      city: values.city,
      postal_code: values.postal_code,
      postal_code_remote: values.postal_code_remote,
      days_spent: parseInt(values.days_spent.charAt(0), 10),
      available_anim_orange_site:
        values.available_place === "available_anim_orange_site" ? 1 : 0,
      available_both: values.available_place === "available_both" ? 1 : 0,
      available_remotely:
        values.available_place === "available_remotely" ? 1 : 0,
      manager_mail: values.manager_mail,
      manager_firstname: values.manager_firstname,
      manager_lastname: values.manager_lastname,
      rgpd_voluntary: values.rgpd_voluntary,
      digital_innovation: values.digital_innovation,
      environment: values.environment,
      digital_tools: values.digital_tools,
      digital_inclusion: values.digital_inclusion,
      work_study: values.work_study
    };
    return payload;
  }

  // Transforme le format des données reçu pour l'affichage coté front
  shapingData(data): {
    axes: any[];
    programs: any[];
    // events: any[]
  } {
    this.dataHelper = data;
    let axes = [];
    const dynamicValues = {
      axes: axes,
      programs: [],
      // events: [],
    };
    return dynamicValues;
  }

  // Interprete comment les programmes doivent réagir face aux choix de l'utilisateur
  shellOfPrograms(choice): void {
    choice.currentTarget.checked
      ? this.addPrograms(choice.currentTarget.value)
      : this.deletePrograms(choice.currentTarget.value);
  }

  // Ajoute les programmes liés à l'axe fourni dans les valeurs dynamiques
  addPrograms(axeId): void {
    // on récupère les programmes qui doivent être ajouté en ajoutant l'id de l'axe parent
    const findAxe = this.dataHelper.find(
      (axe) => Number(axe.id) === Number(axeId)
    );
    const addPrograms = findAxe
      ? findAxe.businessUnits.map((program) => ({ ...program, axeId }))
      : [];

    // On ajoute les programmes aux valeurs à afficher
    this.dynamicValues = {
      ...this.dynamicValues,
      programs: [...this.dynamicValues.programs, ...addPrograms],
    };
  }

  selectedPrograms(program): void {
    if (program.target.checked) {
      this.programsList.push(program.target.value);
    } else {
      const programIdPositionInArray = this.programsList.indexOf(
        program.target.value.toString()
      );
      this.programsList.splice(programIdPositionInArray, 1);
    }
    this.voluntaryForm.controls.programs_id.updateValueAndValidity();
    this.voluntaryForm.controls.programs_id.markAsTouched();
  }

  deletePrograms(axeId): void {
    // On supprime les programmes avec l'axe'Id correspondant
    // Il faut aussi supprimer les evenements liés aux programmes supprimés
    let programIdsToRemove: string[] = [];
    this.dynamicValues = {
      ...this.dynamicValues,
      programs: this.dynamicValues.programs.filter((program) => {
        if (Number(program.axeId) !== Number(axeId)) {
          return true;
        } else {
          programIdsToRemove.push(program.id);
          return false;
        }
      }),
    };
  }

  getRegionsHelperByIds(ids: number[]): { id: number; name: string }[] {
    const regionsHelper: { id: number; name: string }[] = [
      { id: 1, name: "Ile-de-France" },
      { id: 2, name: "Grand Nord-Est" },
      { id: 3, name: "Grand Sud-Est" },
      { id: 4, name: "Grand Sud-Ouest" },
      { id: 5, name: "Grand Ouest" },
      { id: 6, name: "Réunion-Mayotte" },
      { id: 7, name: "Caraïbes" },
      { id: 8, name: "Autre hors France" },
    ];
    return regionsHelper.filter((obj) => ids.includes(obj.id));
  }

  completeDoZone(entity) {
    if (entity === "Orange France") {
      this.voluntaryForm
        .get("entity_orangefrance")
        .setValidators([Validators.required]);
      this.voluntaryForm.get("entity_orangefrance").updateValueAndValidity();
    } else {
      this.voluntaryForm.get("entity_orangefrance").clearValidators();
      this.voluntaryForm.get("entity_orangefrance").updateValueAndValidity();
    }
    switch (entity) {
      case "Communication, Marque et Engagement": // 1
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Direction de la Stratégie et des activités de Cyber-Sécurité": // 2
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Direction Générale": // 3
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Direction People et Transformation Groupe": // 4
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Finance et Performance Groupe": // 5
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Mobile Finance": // 6
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Opérations du Groupe en Europe": // 7
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Orange Business Services": // 8
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Orange Content": // 9
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Orange Digital Investments": // 10
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Orange Digital Venture": // 11
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Orange France": // 12
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Orange Innovation": // 13
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Orange Middle East & Africa": // 14
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Responsabilité Sociétale": // 15
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Secrétariat Général du Groupe": // 16
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "TOTEM group": // 17
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "UK Group Functions": // 18
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Wholesale et International Networks": // 19
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;

      case "Autre": // 20
        this.regionsHelper = this.getRegionsHelperByIds([
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
        ]);
        this.disabledZoneDo = false;
        break;
    }
  }

  public buttonWording() {
    switch (this.step) {
      case "one":
        return "Suivant";
      case "two":
        return "Suivant";
      case "three":
        return "Valider ma demande";
      case "four":
        return "Se connecter à la plateforme";
      default:
        break;
    }
  }

  public infosSubButtonWording() {
    switch (this.step) {
      case "three":
        return "Votre manager sera prévenu de votre inscription";
      case "four":
        return "Pour vous connecter à la plateforme, munissez vous de vos identifiants reçus par mail à l’instant.";
      default:
        return "";
    }
  }

  public nextStep(step) {
    switch (step) {
      case "one":
        return (this.step = "two");
      case "two":
        return (this.step = "three");
      case "four":
        return (window.location.href =
          environment.apiBaseUri+"/admin/login");
      default:
        break;
    }
  }

  public previousStep(step) {
    switch (step) {
      case "two":
        return (this.step = "one");
      case "three":
        return (this.step = "two");

      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/form-voluntary/form-voluntary.component.ts